<template>
<div class="blank">
    <group title="遇到问题，看看以下答案能否解答" type="hint">
        <cell v-for="(item, index) in helplist" :key="index" class="help" height="60" :title="item.title" @click="nextRoute(index)">
            <div slot="right">
                <img class="icon" src="../assets/images/link.png" height="12" width="7" alt="">
            </div>
        </cell>
    </group>
    <loading v-show="isLoading"></loading>
</div>
</template>

<script>
import {
    Group,
    Cell
} from 'fiui'
// import {
//     list
// } from '../utils/faq.js'
import storage from '../utils/storage'
import Loading from '../components/loading';
import {ddcms} from '../api/axios';

export default {
    data() {
        return {
            helplist: [],
            isLoading:false
        }
    },
    components: {
        Group,
        Cell,
        Loading
    },
    created() {
        // this.helplist = list[window._helpIndex]
        // console.log(storage.get('nowCategory'));
        let nowCategory=storage.get('nowCategory')
        this.isLoading=true;
        ddcms({
            id: 'helpCenterAPI.queryHelpCenterList',
            param: {
                "categoryId":nowCategory.categoryId,
                "status":"1000"
            }
        }).then((res) => {
            if (res.status == 200) {
                this.isLoading=false;
                if (res.data.code == "1") {
                    let dataList = res.data.data.data
                    // console.log(res,'标题');
                    let titleContentList = []
                    dataList.forEach((e) => {
                        titleContentList.push({
                            'title':e.title,
                            'context':e.context
                        })
                    })
                    this.helplist=titleContentList;
                }else{
                    alert('查询接口失败')
                }
            }
        }).catch((error) => {
            this.isLoading = false
            alert('请求失败')
        })

    },
    beforeRouteEnter(to, from, next) {
        document.title = '帮助中心'
        next()
    },
    mounted() {

    },
    methods: {
        nextRoute(index) {
            window._helpItemIndex = index
            storage.set({'titleContent':this.helplist[index]})
            this.$router.push('helpdetail')
        }
    }
}
</script>



// WEBPACK FOOTER //
// help.vue?5fb848d4